jQuery(function ($) {
    $(document).ready(function () {
        // Maintain aspect ratio (calculate height based on width).
        $('*[data-aspectRatio]').each(function () {
            var $this = $(this);

            var f = function () {
                var aspectRatio = parseFloat($this.attr('data-aspectRatio'));

                $this.css('height', $this.width() * aspectRatio);
            };

            // Initial calculation.
            f();

            // Immediately trigger matchHeight.
            //$.fn.matchHeight._update();alert(1);
            $(window).load();

            // Recalculate on each window resize.
            $(window).resize(f);
        });

        // Fix footer for small documents.
        var f = function () {
            var windowHeight = $(window).height();
            var documentHeight = $('body > header').outerHeight() + $('body > div.wrap').outerHeight() + $('body > footer').outerHeight();
            if (windowHeight < documentHeight) {
                $('body').removeClass('smaller-than-window');
            } else {
                $('body').addClass('smaller-than-window');
            }
        };
        $(window).on('resize', f);
        $(document).on('ready', f);

        // Buttons
        $("[data-animate-anchor]").click(function () {
            var menuOffset = window.innerWidth >= 768 ? 62 : 0;
            $('html, body').animate({
                scrollTop: $($(this).attr('data-animate-anchor')).first().offset().top - menuOffset
            }, 500);

            return false;
        });

        var swipeboxOptions = {
            useCSS: true,
            useSVG: true,
            hideCloseButtonOnMobile: false,
            removeBarsOnMobile: false,
            hideBarsDelay: 0,
            loopAtEnd: false,
        };
        $('.entry-content [class*="wp-image-"]').parent().swipebox(swipeboxOptions);
        $('a[rel*="lightbox"], a[data-rel*="lightbox"]').swipebox(swipeboxOptions);
    });

    // Allow language sub-menu to open on click/tap on small screens.
    $('.language-menu-item').on('click touch', function () {
        if ($(window).width() < 768) {
            $('.sub-menu').slideToggle();
        }
    });
});
